import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';

const statusColors = {
  available: 'bg-green-500/20 text-green-400 border-green-500/30',
  reserved: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  sold: 'bg-red-500/20 text-red-400 border-red-500/30',
};

const VehicleList = ({ vehicles, onEdit, onDelete }) => {
  if (vehicles.length === 0) {
    return (
      <div className="text-center py-16 text-gray-500">
        <p className="text-lg">No vehicles in inventory yet.</p>
        <p className="text-sm mt-2">Add your first vehicle or import the default collection.</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-white/10 text-left">
            <th className="pb-4 pr-4 text-xs font-bold text-gray-400 uppercase tracking-wider">Image</th>
            <th className="pb-4 pr-4 text-xs font-bold text-gray-400 uppercase tracking-wider">Vehicle</th>
            <th className="pb-4 pr-4 text-xs font-bold text-gray-400 uppercase tracking-wider">Category</th>
            <th className="pb-4 pr-4 text-xs font-bold text-gray-400 uppercase tracking-wider">Status</th>
            <th className="pb-4 pr-4 text-xs font-bold text-gray-400 uppercase tracking-wider">Order</th>
            <th className="pb-4 text-xs font-bold text-gray-400 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((vehicle) => (
            <tr key={vehicle.id} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
              <td className="py-4 pr-4">
                {vehicle.imageUrl ? (
                  <img
                    src={vehicle.imageUrl}
                    alt={vehicle.name}
                    className="w-16 h-12 object-cover rounded-lg border border-white/10"
                  />
                ) : (
                  <div className="w-16 h-12 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-xs text-gray-500">
                    No img
                  </div>
                )}
              </td>
              <td className="py-4 pr-4">
                <p className="font-semibold text-white">{vehicle.name}</p>
                <p className="text-sm text-gray-500 truncate max-w-xs">{vehicle.tagline}</p>
              </td>
              <td className="py-4 pr-4">
                <span className="text-sm text-gray-300 capitalize">{vehicle.category}</span>
              </td>
              <td className="py-4 pr-4">
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border capitalize ${statusColors[vehicle.status] || statusColors.available}`}>
                  {vehicle.status}
                </span>
              </td>
              <td className="py-4 pr-4 text-sm text-gray-400">{vehicle.sortOrder ?? 0}</td>
              <td className="py-4">
                <div className="flex gap-2">
                  <button
                    onClick={() => onEdit(vehicle)}
                    className="p-2 rounded-lg text-[#3DED97] hover:bg-[#3DED97]/10 transition-colors"
                    title="Edit"
                  >
                    <Pencil className="h-4 w-4" />
                  </button>
                  <button
                    onClick={() => onDelete(vehicle)}
                    className="p-2 rounded-lg text-red-400 hover:bg-red-500/10 transition-colors"
                    title="Delete"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VehicleList;
